module.exports = __webpack_public_path__ + "images/places/asm_79-fe472d37f40cbc24485c3863c39c6002.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/places/asm_79.jpg
 ** module id = 312
 ** module chunks = 0
 **/